<yc-typeahead-select
  [showClear]="false"
  [disabled]="isViewOnly"
  [items]="evaluationTypeSelectOptions"
  [value]="evaluationType"
  (valueChange)="handleEvaluationTypeChange($event)">
</yc-typeahead-select>